import { render, staticRenderFns } from "./createTicket.vue?vue&type=template&id=a3fb5ebe"
import script from "./createTicket.vue?vue&type=script&lang=js"
export * from "./createTicket.vue?vue&type=script&lang=js"
import style0 from "./createTicket.vue?vue&type=style&index=0&id=a3fb5ebe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports